<template>
  <v-row class="fill-height">
    <v-col class="fill-height">
      <v-card
        class="my-page-1-card pb-2"
        elevation="4"
        dark
        :loading="isUpdating"
      >
        <!--  -->
        <v-card-title><strong>請選擇想要查詢的項目</strong></v-card-title>
        <!--  -->
        <v-card-actions>
          <v-slide-group show-arrows>
            <v-slide-item
              v-for="(item, i) in !isUpdating
                ? components.list
                : [{ text: '更新...' }]"
              :key="'vsi_' + i"
            >
              <v-btn
                large
                class="mx-1 black--text"
                rounded
                color="amber"
                @click="handleOnClickCp(i, item)"
              >
                <strong>{{ item.text }}</strong>
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-card-actions>
      </v-card>
      <!--  -->
      <v-row class="ml-0 mr-0 mt-4 my-page1-board">
        <div>
          <v-btn download color="success" @click="handleOnClickDownload">
            報表下載
          </v-btn>
        </div>
        <v-expansion-panels v-model="boardPanel" multiple dark>
          <v-expansion-panel
            v-for="(item, i) in !isUpdating
              ? boards.length > 0
                ? boards
                : defaultBoards
              : updateBoards"
            :key="'vep_' + i"
            class="my-vep"
          >
            <v-expansion-panel-header class="my-veph">
              <strong style="font-size: 24px;">{{ item.name }}</strong>
              {{ item.update_time ? `更新時間:${item.update_time}` : '' }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="my-vepc">
              <v-row>
                <v-col v-html="item.content"></v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
// eslint-disable-next-line no-unused-vars
import axios from 'axios'
export default {
  data: () => ({
    // Board
    defaultBoards: [
      {
        name: '暫無公告',
        content: ''
      }
    ],
    updateBoards: [
      {
        name: '更新中...',
        content: ''
      }
    ],
    boardPanel: [0],
    // Download File
    dlTopPath:
      process.env.NODE_ENV === 'development'
        ? 'http://localhost/p221001/public/images/'
        : 'images/',
    dlLink: '',
    //
    nothing: undefined
  }),
  computed: {
    ...mapState('account', ['user', 'uid']),
    ...mapState('forward', ['isUpdating', 'system', 'components', 'boards'])
  },
  methods: {
    ...mapActions('forward', ['getHome', 'updateDownloadCount']),
    // Components
    handleOnClickCp(idx, item) {
      sessionStorage.setItem('listIdx', idx)
      sessionStorage.setItem('listId', item.value)
      sessionStorage.setItem('listName', item.text)
      //
      let paths = {
        '/page1': 'page2',
        '/memberp1': 'memberp2'
      }
      this.$emit('changePage', { path: paths[window.location.pathname] }, 1)
      // this.$router.push({ name: 'page2' })
    },
    handleOnClickDownload() {
      ;(async () => {
        this.updateDownloadCount({})

        const url =
          process.env.NODE_ENV === 'development'
            ? 'http://localhost/p221001/public/api/qdownload.php'
            : 'api/qdownload.php'
        const link = document.createElement('a')
        link.href = url
        link.download = 'download'
        link.click()
        URL.revokeObjectURL(link.href)
      })()
    }
  },
  mounted() {},
  created() {
    this.$emit('setTab')
    ;(async () => {
      const { user, uid } = this
      await this.getHome({ user, uid })
    })()
    // alert(document.documentElement.clientWidth)
    // this.dlLink = this.dlTopPath + this.system.dl_file
  }
}
</script>

<style lang="scss">
.my-page-1-card {
  .v-btn {
    font-size: 20px !important;
  }
}

.my-page1-board {
  .v-btn {
    font-size: 20px !important;
  }
}

.v-tabs-items {
  background-color: rgb(0, 0, 0, 0) !important;
}
.v-card,
.my-vep {
  background-color: rgba(37, 37, 37, 0.8) !important;
}
.my-veph {
  /* color: black !important; */
  background-color: rgb(66, 66, 66, 1) !important;
}
.my-vepc {
  /* color: black !important; */
  color: white !important;
  /* background-color: rgb(255, 255, 255, 1) !important; */
  /* padding: 5px; */
}
</style>
